import React from 'react';
import styled from '@emotion/styled';
import { TLCode } from '../../common/enums';
import { TranslatedMessage } from '../common/translation';
import { observer } from 'mobx-react';
import { Intent, Spinner } from '@blueprintjs/core';
import { AppConfirm } from '../common/modals/AppConfirm';

interface MainSectionLayoutProps {
  title?: TLCode;
  renderHeader?: (props: { Title: React.SFC<TitleProps>; getRootProps: (args: {}) => {} }) => JSX.Element;
  children?: React.ReactNode | React.ReactNode[];
  isLoading?: boolean;
  renderRightComponent?: () => JSX.Element;
}

interface TitleProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement> {}

const PageContainer = styled.div`
  padding: 5px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  align-content: stretch;
  flex: 1;
  background-color: #f5f8fa;
  width: 100%;
  height: 100%;
`;

const TitleContainer = styled.div`
  display: flex;
  align-self: center;
  margin-top: 1em;
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0 5%;
`;

const RightContainer = styled.div`
  display: flex;
  align-self: flex-end;
  margin-bottom: 2px;
`;

const ContentContainer = styled.div`
  flex: 1;
  height: 100%;
  width: 100%;
  padding: 1px 5%;
  margin-left: auto;
  margin-right: auto;
  overflow: auto;
`;

const SpinnerContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

@observer
class MainSectionLayout extends React.Component<MainSectionLayoutProps> {
  renderTitle = (titleProps?: TitleProps) => {
    const { title } = this.props;
    return title ? (
      <h1 {...titleProps}>
        <TranslatedMessage id={title}>{(value) => value}</TranslatedMessage>
      </h1>
    ) : null;
  };

  getRootProps = (props) => ({
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    scrolling: false,
    ...props,
  });

  public render() {
    const { renderHeader, children, isLoading, renderRightComponent } = this.props;
    return (
      <PageContainer>
        <HeaderContainer>
          <div />
          <TitleContainer>
            {renderHeader
              ? renderHeader({
                  Title: this.renderTitle,
                  getRootProps: this.getRootProps,
                })
              : this.renderTitle()}
          </TitleContainer>
          <RightContainer>{renderRightComponent && renderRightComponent()}</RightContainer>
        </HeaderContainer>
        <ContentContainer>
          {isLoading ? (
            <SpinnerContainer>
              {/* <Spin /> */}
              <Spinner intent={Intent.PRIMARY} size={Spinner.SIZE_STANDARD} />
            </SpinnerContainer>
          ) : (
            children
          )}
        </ContentContainer>
        <AppConfirm />
      </PageContainer>
    );
  }
}

export default MainSectionLayout;
